import type {NavigationGuardReturn, RouteLocationNormalized} from 'vue-router';
import ResourceRepository from '../../api/repositories/ResourceRepository';

export async function handleQrCode(to: RouteLocationNormalized): Promise<NavigationGuardReturn> {
    const resourceId = to.params.resourceId;

    if (!resourceId) {
        return {name: 'Home'};
    }

    try {
        const resourceCheck = await ResourceRepository().check(resourceId);
        return {
            name: 'BookingMap',
            params: {roomId: resourceCheck.resource.room},
            query: {resourceId: resourceCheck.resource.id},
        };
    } catch {
        return {name: 'Home'};
    }
}
